import React, { createContext, useContext, useEffect, useState } from "react";
import { doc, setDoc, getDoc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    if (!user) { setWishlist([]); return; }
    getDoc(doc(db, "wishlists", user.uid)).then(snap => {
      if (snap.exists()) setWishlist(snap.data().productIds || []);
      else setDoc(doc(db, "wishlists", user.uid), { productIds: [] });
    });
  }, [user]);

  async function toggleWishlist(productId) {
    if (!user) return false;
    const ref = doc(db, "wishlists", user.uid);
    if (wishlist.includes(productId)) {
      await updateDoc(ref, { productIds: arrayRemove(productId) });
      setWishlist(w => w.filter(id => id !== productId));
      return false;
    } else {
      await updateDoc(ref, { productIds: arrayUnion(productId) });
      setWishlist(w => [...w, productId]);
      return true;
    }
  }

  const isWishlisted = (id) => wishlist.includes(id);

  return (
    <WishlistContext.Provider value={{ wishlist, toggleWishlist, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error("useWishlist must be inside WishlistProvider");
  return ctx;
}
